<template>
	<section
		class="view-layout-actionpanel"
		v-bind:class="{
			'show-global-menu': $store.getters.showPrimaryContextMenu,
		}"
		v-on:pointerdown.stop="Handle_OnPointerDown"
	>
		<section class="action-list">
			<section class="action-item action-submit" v-on:click="Handle_OnClickAction('submit')">
				<figure class="icon-container">
					<img class="filter-invert" src="~@chalkysticks/sass/build/asset/image/icon/pin.svg" />
				</figure>

				<h5>Add a Spot</h5>
				<p>Found a new spot we don&rsquo;t have yet? Upload a picture!</p>
			</section>

			<section class="action-item action-checkin" v-on:click="Handle_OnClickAction('checkin')">
				<figure class="icon-container">
					<img class="filter-invert" src="~@chalkysticks/sass/build/asset/image/icon/chalkysticks.svg" />
				</figure>

				<h5>Check in</h5>
				<p>If you&rsquo;re out shooting, let people the spot.</p>
			</section>

			<!-- <section class="action-item action-addphoto" v-on:click="Handle_OnClickAction('post')">
				<figure class="icon-container">
					<img class="filter-invert" src="~@chalkysticks/sass/build/asset/image/icon/camera.svg" />
				</figure>

				<h5>Post a Shot</h5>
				<p>Upload an image or video of you and your friends playing pool.</p>
			</section> -->

			<section class="action-item action-addphoto" v-on:click="Handle_OnClickAction('create')">
				<figure class="icon-container">
					<img class="filter-invert" src="~@chalkysticks/sass/build/asset/image/icon/rack-9ball.svg" />
				</figure>

				<h5>Mark it up</h5>
				<p>Diagram a shot and share it with your friends.</p>
			</section>

			<section class="action-item action-addvideo" v-on:click="Handle_OnClickAction('play')">
				<figure class="icon-container">
					<img class="filter-invert" src="~@chalkysticks/sass/build/asset/image/icon/video-play.svg" />
				</figure>

				<h5>Shoot a Rack</h5>
				<p>Play a game of pool and challenge your friends.</p>
			</section>

			<!-- <section>
			<h5>Start Challenge</h5>
			<p>Play your friends in a game of pool using our game!</p>
		</section> -->
		</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, bind, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Layout
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewLayoutActionPanel extends ViewBase {
		/**
		 * @return void
		 */
		@mounted
		public attachEvents(): void {
			document.addEventListener('pointerdown', this.Handle_OnDocumentPointerDown);
		}

		/**
		 * @return void
		 */
		@beforeDestroy
		public detachEvents(): void {
			document.removeEventListener('pointerdown', this.Handle_OnDocumentPointerDown);
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param string action
		 * @return Promise<void>
		 */
		protected async Handle_OnClickAction(action: string): Promise<void> {
			ChalkySticks.Core.Event.Bus.dispatch('action:global', { action });
			this.$emit('action', action);
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		@bind
		protected async Handle_OnDocumentPointerDown(e: PointerEvent): Promise<void> {
			if (this.$store.getters.showPrimaryContextMenu) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();

				this.$store.commit('setShowPrimaryContextMenu', false);
			}
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		@bind
		protected async Handle_OnPointerDown(e: PointerEvent): Promise<void> {
			if (this.$store.getters.showPrimaryContextMenu) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
			}
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-layout-actionpanel {
		background-color: var(--chalky-blue);
		bottom: 0;
		height: var(--global-action-menu-height);
		left: 0;
		padding: 0.5rem 1rem 1rem 1rem;
		position: fixed;
		right: 0;
		transition: transform 0.3s ease, opacity 0.3s ease;
		z-index: var(--z-header-mid);

		.action-list {
			display: flex;
			flex-direction: column;
			gap: 4px;
		}

		.action-item {
			background-color: var(--chalky-blue-5);
			border-radius: 0.5rem;
			padding: 1rem;

			.icon-container {
				align-items: center;
				border-radius: 0.5rem;
				display: flex;
				float: left;
				height: 60px;
				justify-content: center;
				margin-right: 1rem;
				width: 60px;

				img {
					height: 24px;
					width: 24px;
				}
			}

			p {
				color: var(--chalky-grey-2);
				font-size: 0.875rem;
				padding-right: 3rem;
			}
		}

		.action-item figure {
			background-color: var(--chalky-blue-3);
		}

		/*
		.action-item:nth-child(1) figure {
			background-color: color-mix(in srgb, var(--chalky-ball-1) 50%, var(--chalky-blue-3));
		}

		.action-item:nth-child(2) figure {
			background-color: color-mix(in srgb, var(--chalky-ball-2) 50%, var(--chalky-blue-3));
		}

		.action-item:nth-child(3) figure {
			background-color: color-mix(in srgb, var(--chalky-ball-3) 50%, var(--chalky-blue-3));
		}

		.action-item:nth-child(4) figure {
			background-color: color-mix(in srgb, var(--chalky-ball-4) 50%, var(--chalky-blue-3));
		}

		.action-item:nth-child(5) figure {
			background-color: color-mix(in srgb, var(--chalky-ball-5) 50%, var(--chalky-blue-3));
		}

		.action-item:nth-child(6) figure {
			background-color: color-mix(in srgb, var(--chalky-ball-6) 50%, var(--chalky-blue-3));
		}
		*/
	}

	// State
	// ---------------------------------------------------------------------------

	.view-layout-actionpanel:not(.show-global-menu) {
		transform: translate(0, 100%);
		opacity: 0;
		pointer-events: none;
	}
</style>
